import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const navLinks = [
  { id: "accueil", label: "Accueil", path: "/" },
  { id: "services", label: "Services", path: "/services" },
  { id: "zones", label: "Zones", path: "/zones" },
  { id: "guides", label: "Guides", path: "/guides" },
  { id: "actualites", label: "Actualités", path: "/actualites" },
  { id: "a-propos", label: "À propos", path: "/a-propos" },
  { id: "contact", label: "Contactez", path: "/contact" },
];

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 bg-white border-b border-brand-blue/15 z-30" data-testid="header">
      <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="header-logo-link">
          <img
            src="/logo-fast-alu.png"
            alt="Fast Alu logo"
            className="h-14 md:h-16 w-auto"
            data-testid="header-logo-image"
          />
          <div className="hidden sm:block">
            <p className="font-heading text-xl uppercase" data-testid="header-logo-text">
              Fast Alu
            </p>
          </div>
        </Link>
        <nav className="hidden lg:flex items-center gap-2" data-testid="header-nav">
          {navLinks.map((link) => (
            <NavLink
              key={link.path}
              to={link.path}
              className={({ isActive }) =>
                `text-xs uppercase tracking-wider font-semibold px-3 py-2 rounded-full transition ${
                  isActive ? "bg-brand-red/10 text-brand-red" : "text-brand-ink hover:bg-brand-blue/10"
                }`
              }
              data-testid={`nav-link-${link.id}`}
            >
              {link.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          <a
            href="tel:0184160307"
            className="text-xs uppercase tracking-wider font-semibold border border-brand-red text-brand-red px-4 py-2 rounded-full"
            data-testid="header-phone-link"
          >
            01 84 16 03 07
          </a>
          <Link
            to="/contact"
            className="bg-brand-red text-white px-4 py-2 rounded-full uppercase text-xs font-bold"
            data-testid="header-quote-link"
          >
            Devis gratuit
          </Link>
        </div>
        <button
          className="lg:hidden text-brand-ink"
          onClick={() => setMenuOpen((prev) => !prev)}
          data-testid="mobile-menu-toggle"
          aria-label="Menu"
        >
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {menuOpen && (
        <div className="lg:hidden border-t border-brand-blue/15 bg-white px-4 py-4" data-testid="mobile-menu">
          <div className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <NavLink
                key={link.path}
                to={link.path}
                onClick={() => setMenuOpen(false)}
                className="text-sm uppercase tracking-wider font-semibold text-brand-ink"
                data-testid={`mobile-nav-link-${link.id}`}
              >
                {link.label}
              </NavLink>
            ))}
            <a
              href="tel:0184160307"
              className="text-sm font-semibold text-brand-red"
              data-testid="mobile-phone-link"
            >
              01 84 16 03 07
            </a>
            <Link
              to="/contact"
              onClick={() => setMenuOpen(false)}
              className="bg-brand-red text-white px-4 py-2 rounded-full uppercase text-xs font-bold text-center"
              data-testid="mobile-quote-link"
            >
              Devis gratuit
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
